import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosPost from "../axios/axios-post";
import axiosGet from "../axios/axios-get";
import axiosDelete from "../axios/axios-delete";
import axiosPut from "../axios/axios-put";

const BASE_URL = "/service";

export const ServicesAPI = Object.freeze({
  getAll: createAsyncThunk("get/services", async (_, { rejectWithValue }) => {
    try {
      const response = await axiosGet.get(BASE_URL, {
        headers: { locale: "am" },
        // refactor locale to be dynamic
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }),

  getOne: createAsyncThunk(
    "get/one-service",
    async (id, { rejectWithValue }) => {
      try {
        const response = await axiosGet.get(BASE_URL + `/${id}`);
        return response.data;
      } catch (error) {
        return rejectWithValue(error.response?.data || error.message);
      }
    }
  ),

  create: createAsyncThunk(
    "post/service",
    async (data, { rejectWithValue }) => {
      try {
        const response = await axiosPost.post(BASE_URL, data);
        return response.data;
      } catch (error) {
        return rejectWithValue(error.response?.data || error.message);
      }
    }
  ),

  update: createAsyncThunk(
    "update/service",
    async (formData, { rejectWithValue }) => {
      try {
        const response = await axiosPut.put(
          BASE_URL + `/${formData?.id}`,
          formData
        );
        return response.data;
      } catch (error) {
        return rejectWithValue(error.response?.data || error.message);
      }
    }
  ),

  delete: createAsyncThunk(
    "delete/service",
    async (id, { rejectWithValue }) => {
      try {
        const response = await axiosDelete.delete(BASE_URL + `/${id}`);
        return response.data;
      } catch (error) {
        return rejectWithValue(error.response?.data || error.message);
      }
    }
  ),
});
